<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Tabs</h1>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <ui-platform-tabs [tabs]="tabs">
      <ng-template #tab1> Tab 1 content </ng-template>
      <ng-template #tab2> Tab 2 content </ng-template>
      <ng-template #tab3> Tab 3 content </ng-template>
    </ui-platform-tabs>
  </div>
</div>
